import { AuthService } from './../../services/auth.service';
import { CommonService } from './../../services/common.service';
import { Component, OnInit, HostBinding} from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { slideToRight } from '../../shared/animations.collections';
import { CreateEventService } from '../../nav/shared/createevent.listener';
import { FormBuilder, FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { UserInfoViewModel, MfaModel } from '../../models/account-ledger.model';
import { passwordInfo } from '../../models/Profile-view.model';
import { MyAccountService } from '../../services/myAccount.service';
import { EnableMfaComponent } from '../../popup-collection/enable-mfa/enable-mfa.component';
import { UpdateEmailMobileComponent } from '../../popup-collection/update-email-mobile/update-email-mobile.component';
import { MatDialog } from '@angular/material/dialog';


declare var $: any;

// Custom Validator used to match password entered
function passwordMatcher(c: AbstractControl) {
  const newPasswordControl = c.get('newPassword');
  const confirmNewPasswordControl = c.get('confirmNewPassword');
  if (newPasswordControl.pristine || confirmNewPasswordControl.pristine) {
    return null;
  }
  if (newPasswordControl.value === confirmNewPasswordControl.value) {
    return null;
  }
  return {'match' : true};
}

@Component({
  selector: 'app-person-info',
  templateUrl: './person-info.component.html',
  styleUrls: ['./person-info.component.css'],
  providers: [MyAccountService],
  animations: [slideToRight('100%')],
})
export class PersonInfoComponent implements OnInit {
  @HostBinding('@slideToRight') ani;

  title = 'My Information';
  accessLevel: string;
  closeResult: string;
  userInfoForm: FormGroup;
  passwordUpdateForm: FormGroup;
  confirmPWD: string;
  currentUserModel: UserInfoViewModel;
  updatedUserInfo: UserInfoViewModel = <UserInfoViewModel>{};
  passwordArr: passwordInfo = <passwordInfo>{};
  loadContent = true;
  enabledMFA = false;
  mfaOption = '';
  sendingMethod = '';
  emailAddress: string;
  mobileNumber: string;
  isEmailExist = false;
  isMobileExist = false;
  userInfoModel: UserInfoViewModel = <UserInfoViewModel>{};
  modalReference: NgbModalRef;
  updateMfaModel: MfaModel = <MfaModel>{};
  passwordStatus: any;


  constructor(
    private pageService: CreateEventService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private myAccountService: MyAccountService,
    public commonService: CommonService,
    private authService: AuthService,
    public dialog: MatDialog
  ) {
  }

  // Using ng-bootstrap Dependency -------- Bootstrap Modal
  open(content, event) {
    event.preventDefault();
    event.stopPropagation();
    this.modalReference = this.modalService.open(content, {centered: true, backdrop: 'static'});
    this.modalReference.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
        console.log('result : ', result);
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        console.log('reason : ', reason);
        // reset all the form inputs and hide the validation message.
        this.passwordUpdateForm.reset();
        Object.keys(this.passwordUpdateForm.controls).forEach(key => {
          this.passwordUpdateForm.get(key).markAsUntouched();
          this.passwordUpdateForm.get(key).markAsPristine();
        });
      }
    );
  }
  

  private getDismissReason(reason: any): string {
    console.log('reason : ', reason);
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  closePWDContainer(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  ngOnInit() {

    this.userInfoForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      mobileNumber: [''],
      email: ['', this.commonService.emailValidatorRegex()],
    });

    this.passwordUpdateForm = this.fb.group({
      oldPassword: ['', Validators.required],
      newPasswordGroup: this.fb.group({
        newPassword: ['', Validators.required],
        confirmNewPassword: ['', Validators.required],
      }, {validator: passwordMatcher}),

    });

    this.myAccountService.GetSalesDocuments('').subscribe((res: UserInfoViewModel) => {
      this.currentUserModel = res;
      this.userInfoForm.patchValue(res);

      this.mfaOption = res.mfaEnabled;
      this.enabledMFA = (this.mfaOption === 'M' || this.mfaOption === 'E');
      if (this.enabledMFA) {
        this.sendingMethod = this.mfaOption === 'M' ? 'MOBILE' : 'EMAIL';
      }

      this.emailAddress = res.email;
      this.mobileNumber = res.mobileNumber;

      // TODO: Get the access level data from the backend
      if (this.currentUserModel.isAdmin && this.currentUserModel.isPurchaseOfficer) {
        this.accessLevel = 'Admin | Purchase | View';
      } else if (!this.currentUserModel.isAdmin && this.currentUserModel.isPurchaseOfficer) {
        this.accessLevel = 'Purchase | View';
      } else if (!this.currentUserModel.isAdmin && !this.currentUserModel.isPurchaseOfficer) {
        this.accessLevel = 'View';
      } else if (this.currentUserModel.isAdmin && !this.currentUserModel.isPurchaseOfficer) {
        this.accessLevel = 'Admin | View';
      }
    },
      (error: any) => {
        console.error(error);
      });
  }

  clickEnableSMS(event: any): void {
    event.preventDefault();
    event.stopPropagation();

    this.enabledMFA = !this.enabledMFA;

    if (this.enabledMFA) {
      const dialogRef = this.dialog.open(EnableMfaComponent, {
        width: '400px',
        data: {
          emailAddress: this.emailAddress,
          mobileNumber: this.mobileNumber,
          mfaOption: this.mfaOption
         }
      });

      dialogRef.afterClosed().subscribe(response => {

        if (response) {
          this.enabledMFA = true;
          this.sendingMethod = response.toUpperCase();
        }
      });
    } else {
    // disabled MFA
      this.disableMFA();
    }

  }

  disableMFA(): void {
      const mfamodel = {} as MfaModel;
      mfamodel.mobile = this.mobileNumber;
      mfamodel.email = this.emailAddress;
      mfamodel.mfaEnabled = 'N';
      this.myAccountService.UpdateUserMFAOption(mfamodel).subscribe((data: any) => {

        if (data.status === true) {
          this.sendingMethod = '';
          this.commonService.implementToast('Multi-Factor Authentication has been disabled.', 'Info');
        }
      });
  }



  isFieldValid(field: string): boolean {
    return !this.userInfoForm.get(field).valid && this.userInfoForm.get(field).touched;
  }

  isPasswordValid(field: string): boolean {
    return !this.passwordUpdateForm.get(field).valid && this.passwordUpdateForm.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'error-wrapper': this.isFieldValid(field),
    };
  }

  displayPasswordFieldCss(field: string) {
    return {
      'error-wrapper': this.isPasswordValid(field),
    };
  }

  closePage() {
    this.pageService.destoryComponent('person');
  }

  updatePersonalInfo() {

    if (this.userInfoForm.valid) {
      this.loadContent = false;
      this.updatedUserInfo.loginName = this.currentUserModel.loginName;
      this.updatedUserInfo.accountId = this.currentUserModel.accountId;
      this.updatedUserInfo.firstName = this.userInfoForm.get('firstName').value;
      this.updatedUserInfo.lastName = this.userInfoForm.get('lastName').value;
      this.updatedUserInfo.email = this.userInfoForm.get('email').value;
      this.updatedUserInfo.mobileNumber = this.userInfoForm.get('mobileNumber').value ? this.userInfoForm.get('mobileNumber').value : '';

      this.myAccountService.UpdateUserProfile(this.updatedUserInfo).subscribe((data: any) => {

        if (data.status === true) {
           $('#btnUpdate').showValidator('Update successful', 'success', 'left');

           // disable mfa if email & mobile not exist
           if (!this.updatedUserInfo.email.length && !this.updatedUserInfo.mobileNumber.length) {
             this.disableMFA();
           }
        }
      });


    } else {
      this.validateAllFormFields(this.userInfoForm);
    }
  }

  updatePWD() {
    // if(this.passwordUpdateForm.valid) {
    if ( this.passwordStatus.passwordIsValidated && this.passwordUpdateForm.valid) {
      this.passwordArr.oldPassword = this.passwordUpdateForm.get('oldPassword').value;
      this.passwordArr.newPassword = this.passwordUpdateForm.get('newPasswordGroup.newPassword').value;


      this.myAccountService.UpdateUserPassword(this.passwordArr).subscribe((data: any) => {
        if (data.status === true) {
          //  $('#btnUpdatePWD').showValidator(data.responseMessage, 'success', 'right');
          this.commonService.implementToast(data.responseMessage, 'Success');
          this.modalReference.close();
        } else {
          // $('#btnUpdatePWD').showValidator(data.responseMessage, 'error', 'right');
          this.commonService.implementToast(data.responseMessage, 'Error');
        }

        this.passwordUpdateForm.reset();
      });

    } else {
      this.validateAllFormFields(this.passwordUpdateForm);
    }
  }

  updateEmailAndMobile(updateOption: string) {
    const dialogRef = this.dialog.open(UpdateEmailMobileComponent, {
      width: '400px',
      panelClass: 'mat-dialog-wrapper',
      data: {
        loginName: this.currentUserModel.loginName,
        accountId: this.currentUserModel.accountId,
        emailAddress: this.emailAddress,
        mobileNumber: this.mobileNumber,
        sendMethod: updateOption
       }
    });

    dialogRef.afterClosed().subscribe(result => {
       if (result) {
         if (updateOption === 'mobile') {
           this.mobileNumber = result;
         } else {
           this.emailAddress = result;
         }
       }
    });
  }

  validateAllFormFields(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(field => {
        const control = formGroup.get(field);
        if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
        } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
        }
    });
  }

  checkPasswordStatus() {
    this.passwordStatus = this.commonService.checkPasswordValidation(this.passwordUpdateForm.controls.newPasswordGroup.value.newPassword);
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

}
